import axios from 'axios'

export default {

    getRolesDataSource(params){
        return axios.get('/role/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getAvailableUserDataSource(params){
        return axios.get('/role/get-available-user/datasource', {params})
            .then(response => {
                return response.data
            })
    }, 
    getViewUser(id){
        return axios.get('/role/' + id + '/view-users')
            .then(response => {
                return response.data
            })
    }, 
    assignUserToRole(id,formdata){
        return axios.post('/role/' + id + '/assign-user', formdata)
            .then(response => {
                return response.data
            })
    },
    getModule(){
        return axios.get('/role/1/get-module')
            .then(response => {
                return response.data
            })
    },
    getViewPermission(id){
        return axios.get('/role/' + id + '/view-permission')
            .then(response => {
                return response.data
            })
    }, 
    assignPermissionToRole(id,formdata){
        return axios.post('/role/' + id + '/assign-permission', formdata)
            .then(response => {
                return response.data
            })
    },
   
    createRole(formdata){
        return axios.post('/role', formdata)
            .then(response => {
                return response.data
            })
    },
    updateRole(id,formdata){
        return axios.put('/role/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deleteRole(id){
        return axios.delete('/role/' + id)
            .then(response => {
                return response.data
            })
    },
    getRolebyID(id){
        return axios.get('/role/' + id)
            .then(response => {
                return response.data
            })
    }, 
}